/**
 * 通用资源列表控制条 — 播片配置（维护入口）。
 *
 * 用途：idle 态（无筛选、无勾选）时，中间显示屏按序轮播 scope 默认态与版本升级说明。
 * 维护方式：新增/修改 slides 条目；不再播放时将 enabled 设为 false 或删除条目。
 * 不做过期时间与「知道了」关闭；停留时长由 dwellMs 控制，全部资源应最长。
 */
export const CONTROL_BAR_BROADCAST = {
  /** 鼠标悬停显示屏时暂停轮播，便于运营细读 */
  pauseOnHover: true,

  slides: [
    {
      id: 'scope-default',
      type: 'scope-default',
      enabled: true,
      dwellMs: 4000,
      label: '全部资源',
    },
    {
      id: 'batch-tag-v2',
      type: 'release-note',
      enabled: true,
      dwellMs: 3000,
      title: '批量打标升级',
      /** 单行摘要，控制条内 ellipsis 展示 */
      summary: '卡片式选 Tag；预览 diff 展示变更；弹窗内可移出资源',
      /** 点击当前帧时 Popover 展示的完整说明 */
      detailLines: [
        '页面打标：勾选资源后，点一级分类卡片进入子 Tag 多选',
        '已选资源区点击 × 可移出单条，无需关闭弹窗',
        'Excel 打标：先选模式 → 导出打标表 → 填写操作列 → 上传 → 预览提交',
        '预览变更以 diff 形式展示 Tag 增删，界面不展示 key',
      ],
    },
  ],
}
